import Vue from 'vue'

import * as Sentry from '@sentry/vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { STATS_TYPES, AGGREGATION_LEVELS, Topics } from '@/mqtt/liveStats.js'

// api
import ReactionAPI from '@/api/reaction'

const REACTIONS = {
  LIKE: {
    name: 'like',
    type: 'numberOfLikes',
  },
  HEART: {
    name: 'heart',
    type: 'numberOfHearts',
  },
  LAUGH: {
    name: 'laugh',
    type: 'numberOfLaughs',
  },
  WOW: {
    name: 'wow',
    type: 'numberOfWows',
  },
  SAD: {
    name: 'sad',
    type: 'numberOfSads',
  },
}

export default (ReactionView) => Vue.component('ReactionsController', {
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters('liveStats', ['reactionCountPerType']),
    ...mapGetters('featureToggles', ['canUseKvSyncLiveStats']),
    ...mapGetters({
      slide: 'activeActivity',
    }),
    ...mapState({
      audienceId: (state) => state.audienceId,
      audienceName: (state) => state.audienceName,
      presentation: (state) => state.presentation,
      liveStats: (state) => state.liveStats,
    }),
    reactionCount() {
      return (reaction) => {
        const reactionCount = this.reactionCountPerType(this.presentation.id, this.presentation.version, reaction.name)
        return this.canUseKvSyncLiveStats ? reactionCount : (reactionCount || this.presentation[reaction.type])
      }
    },
  },
  async created() {
    if (this.presentation.id) {
      await this.fetchStatsFromKvSyncAction({
        statsKeys: Object.values(REACTIONS).map((reaction) => Topics.reactionCountPerTypeTopic(this.presentation.id, this.presentation.version, reaction.name)),
      })

      this.subscribeStatsAction({
        statsType: STATS_TYPES.REACTION_COUNT,
        aggregationLevel: AGGREGATION_LEVELS.PER_REACTION_TYPE,
        identifier: this.presentation.id,
      })
    }
  },
  beforeDestroy() {
    if (this.presentation.id) {
      this.unsubscribeStatsAction({
        statsType: STATS_TYPES.REACTION_COUNT,
        aggregationLevel: AGGREGATION_LEVELS.PER_REACTION_TYPE,
        identifier: this.presentation.id,
      })
    }
  },
  methods: {
    ...mapActions('liveStats', [
      'subscribeStatsAction',
      'fetchStatsFromKvSyncAction',
      'unsubscribeStatsAction',
    ]),

    async react(reactionType) {
      if (!this.slide.id) return
      const payload = {
        audienceId: this.audienceId,
        audienceName: this.audienceName,
        slideId: this.slide.id,
        presentationId: this.presentation.id,
        reactionType,
      }

      try {
        await ReactionAPI.createReaction(payload)
      } catch (error) {
        Sentry.captureException(error)
      }
    },
  },
  render(createElement) {
    if (!this.slide.id) return null
    return createElement(ReactionView, {
      props: {
        ...this.$attrs,
        react: this.react,
        presentation: this.presentation,
        numberOfHearts: this.reactionCount(REACTIONS.HEART),
        numberOfLikes: this.reactionCount(REACTIONS.LIKE),
        numberOfWows: this.reactionCount(REACTIONS.WOW),
        numberOfLaughs: this.reactionCount(REACTIONS.LAUGH),
        numberOfSads: this.reactionCount(REACTIONS.SAD),
      },
    })
  },
})
